import React from "react";
import { useField, useFormikContext } from "formik";
import ReactCreatableSelect from "react-select/creatable";
import ReactSelect from "react-select";

import classNames from "classnames";

const CLASS_NAMES = {
  FIELD: "input-field",
  LABEL: "input-field-label",
  INPUT: "input-field-input",
};

const customStyles = {
  control: (provided, state) => {
    return {
      ...provided,
      borderColor: state?.selectProps?.error ? "red" : "#E4E6EF",
      borderRadius: "0 !important",
    };
  },
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 3000,
  }),
  // indicatorSeparator: () => null,
};

const noBorderRadius = {
  control: (provided, state) => {
    return {
      ...provided,
      borderRadius: "0 !important",
      borderColor: "#E4E6EF",
    };
  },
  // indicatorSeparator: () => null,
};

export const CreatableSelect = (props) => (
  <ReactCreatableSelect className={CLASS_NAMES.INPUT} {...props} />
);
export const Select = (props) => (
  <ReactSelect styles={customStyles} className={CLASS_NAMES.INPUT} {...props} />
);

export const SelectInputField = ({
  label,
  labelStyle,
  name,
  rootClassName,
  autoSubmit = false,
  creatable = false,
  id,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { submitForm } = useFormikContext();

  return (
    <div className={`${CLASS_NAMES.FIELD} ${rootClassName || ""}`}>
      {label && (
        <label
          className={classNames(CLASS_NAMES.LABEL, labelStyle)}
          htmlFor={props.id || name}
          id={id}
        >
          {label}
        </label>
      )}
      {creatable ? (
        <CreatableSelect
          className={CLASS_NAMES.INPUT}
          value={field.value}
          name={field.name}
          styles={noBorderRadius}
          onChange={(option) => {
            field.onChange({ target: { name: field.name, value: option } });
            autoSubmit && submitForm();
          }}
          onBlur={() => {
            field.onBlur({ target: { name: field.name } });
            autoSubmit && submitForm();
          }}
          {...props}
          isClearable={true}
        />
      ) : (
        <Select
          className={CLASS_NAMES.INPUT}
          value={field.value}
          name={field.name}
          error={meta.touched && meta.error}
          styles={noBorderRadius}
          onChange={(option) => {
            field.onChange({ target: { name: field.name, value: option } });
            autoSubmit && submitForm();
          }}
          onBlur={() => {
            field.onBlur({ target: { name: field.name } });
            autoSubmit && submitForm();
          }}
          {...props}
          isClearable={true}
        />
      )}
      {meta.touched && meta.error ? (
        <div className="error" style={{ color: "red" }}>
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};
